import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
    TRIPS,
    TIMELINE_TRIPS,
    TRIP_PLAN,
    TIMELINE_PLAN,
    CREATE_TRIP,
    UPDATE_TRIP,
    TRAVEL_GUIDE,
    USE_TRIP_URL,
    LOGIN,
    TRIP_PLANNER_VALAI, EDIT_TIMELINE_TRIP,
} from "../../constants/ROUTER_PATH_TITLE";

import TripList from "../../components/TripList/TripList";
import TimelineTripList from "../../components/TimelineTripList/TimelineTripList";

import useUser from "../../hooks/useUser";
import useTrip from "../../hooks/useTrip";
import useTimelineTrip from "../../hooks/useTimelineTrip";
import AppNav from "../../App/AppNav/AppNav";
import useTranslate from "../../hooks/useTranslate";
import TripAppMenu from "../../App/AppNav/TripMenu/TripAppMenu";
import { SvgIcons } from "@tripian/react";
import { useGuestUserForSimplyCaribbean } from "../../hooks/useGuestUserForSimplyCaribbean";
import { api } from "@tripian/core";
import { useDispatch } from "react-redux";
import { saveNotification } from "../../redux/action/trip";
import Model from "@tripian/model";
// import classes from "./Trips.module.scss";

const TripsPage = () => {
  const { loadingTripReferences, tripReferences, userTripReferencesFetch } =
    useUser();
  const { loadingTripDelete, tripDelete, tripClear } = useTrip();
  const { loadingTimelineTrips, timelineTrips, timelineTripsFetch } = useTimelineTrip();

  const { t } = useTranslate();
  const dispatch = useDispatch();

  const isGuestForSimplyCaribbean = useGuestUserForSimplyCaribbean();
  const isValaiLanding = window.tconfig.LANDING_PAGE === "ValaiLanding";
  const isTimeline = window.tconfig.SHOW_TIMELINE;

  const navigate = useNavigate();
  document.title = TRIPS.TITLE(t("trips.myTrips.title"));

  useEffect(() => {
    if (!window.tconfig.SHOW_HOME && window.tconfig.LOGIN_WITH_HASH) {
      navigate(USE_TRIP_URL.PATH, { replace: true });
    } else if (isValaiLanding || isTimeline) {
      // ValaiLanding için timeline trips kullan
      if (!timelineTrips) timelineTripsFetch();
      else if (isGuestForSimplyCaribbean) {
        navigate(LOGIN.PATH, { replace: true });
      }
    } else {
      // Normal trips
      if (!tripReferences) userTripReferencesFetch();
      else if (isGuestForSimplyCaribbean) {
        navigate(LOGIN.PATH, { replace: true });
      }
    }
  }, [
    isGuestForSimplyCaribbean,
    navigate,
    tripReferences,
    userTripReferencesFetch,
    timelineTrips,
    timelineTripsFetch,
    isValaiLanding,
  ]);

  useEffect(() => {
    tripClear();
  }, [tripClear]);

  const cardClicked = (tripHash: string) => {
    if (isValaiLanding || isTimeline) {
      // ValaiLanding için timeline plan sayfasına git
      navigate(`${TIMELINE_PLAN.PATH}/${tripHash}/0`);
    } else {
      let currentPath: string;
      if (window.tconfig.SHOW_TRAVEL_GUIDE) {
        currentPath = TRAVEL_GUIDE.PATH;
      } else {
        currentPath = TRIP_PLAN.PATH;
      }
      navigate(`${currentPath}/${tripHash}`);
    }
  };

  const cardEditClicked = (tripHash: string) => {
      if (isValaiLanding || isTimeline) {
          navigate(`${EDIT_TIMELINE_TRIP.PATH}/${tripHash}`);
      }else {
          navigate(`${UPDATE_TRIP.PATH}/${tripHash}`);
      }
  };

  const cardDeleteClicked = async (tripHash: string): Promise<boolean> => {
    if (isValaiLanding || isTimeline) {
      // Timeline trip sil
      try {
        await api.tripDelete(tripHash);
        await timelineTripsFetch();
        return true;
      } catch (error) {
        dispatch(
          saveNotification(
            Model.NOTIFICATION_TYPE.ERROR,
            "timelineTripDelete",
            ""
          )
        );
        return false;
      }
    } else {
      // Normal trip sil
      await tripDelete(tripHash);
      return true;
    }
  };

  const handleCreateTripNavigation = () => {
    if (window.tconfig.LANDING_PAGE === "ValaiLanding" || isTimeline) {
      navigate(TRIP_PLANNER_VALAI.PATH);
    } else {
      navigate(CREATE_TRIP.PATH);
    }
  };

  return (
    <div
      className="background-full"
      style={
        window.tconfig.IMAGE_PATHS.APP_BACKGROUND_IMG_URL
          ? {
              background: `url(${window.tconfig.IMAGE_PATHS.APP_BACKGROUND_IMG_URL})`,
            }
          : {}
      }
    >
      <AppNav
        header={TRIPS.HEADER?.(t("trips.myTrips.title")) || ""}
        tripAppMenu={
          <TripAppMenu
            isInTripPlan={false}
            onClickAddTrip={handleCreateTripNavigation}
            t={t}
          />
        }
      />
      <div className="flex w-full justify-between items-center mt-10 px-6 md:hidden">
        <div className="font-semibold text-2xl">
          {TRIPS.HEADER?.(t("trips.myTrips.title")) || ""}
        </div>
        <div
          className="w-10 h-10 bg-primary-color flex justify-center items-center rounded-full cursor-pointer"
          onClick={handleCreateTripNavigation}
        >
          <SvgIcons.Add fill="#fff" />
        </div>
      </div>
      <div className="container mt10">
        <div className="row center">
          {isValaiLanding || isTimeline ? (
            <TimelineTripList
              timelineTrips={timelineTrips || []}
              loadingTimelineTrips={loadingTimelineTrips}
              cardClicked={cardClicked}
              cardEditClicked={cardEditClicked}
              cardDeleteClicked={(hash: string) =>
                cardDeleteClicked(hash).then(() => true)
              }
              tripCreateClicked={handleCreateTripNavigation}
            />
          ) : (
            <TripList
              tripReferences={tripReferences || []}
              loadingTripReferences={loadingTripReferences || loadingTripDelete}
              cardClicked={cardClicked}
              cardEditClicked={cardEditClicked}
              cardDeleteClicked={(hash: string) =>
                cardDeleteClicked(hash).then(() => true)
              }
              tripCreateClicked={handleCreateTripNavigation}
            />
          )}
        </div>
        {/* <div className={classes.tripCreateButton}>
          <CreateIconButton clicked={() => navigate(CREATE_TRIP.PATH)} />
        </div> */}
      </div>
    </div>
  );
};

export default TripsPage;
